import { GlobalStore } from '@web/csl-lib-store';
import { HealthRecordMeta } from '@web/csl-lib-models';
import { HealthRecordMetaState } from './health-record-meta.state';
import { inject } from '@angular/core';
import { HealthRecordMetaService } from './meta-health-record/health-record-meta.service';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { pipe, switchMap, tap } from 'rxjs';
import { rxMethod } from '@ngrx/signals/rxjs-interop';


const initialState: HealthRecordMetaState = {
  healthRecordId: '',
  healthRecordMeta: null,
  isLoading: false,
  error: null
}

export const HealthRecordMetaStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(
    (store,
     healthRecordService = inject(HealthRecordMetaService),
     globalStore = inject(GlobalStore)
  ) => ({
    setHealthRecordId(healthRecordId: string) {
      patchState(store, { healthRecordId: healthRecordId });
    },
    loadHealthRecordMeta: rxMethod<string>(
      pipe(
        switchMap((healthRecordId: string) => {
          globalStore.setLoading();
          patchState(store, { isLoading: true });
          return healthRecordService
            .getHealthRecordMeta(healthRecordId)
            .pipe(
              tap({
                next: (meta: HealthRecordMeta) => {
                  // Store IDs as upper case to make comparisons case-insensitive
                  meta.id = meta.id.toUpperCase();
                  meta.ownerUserId = meta.ownerUserId.toUpperCase();
                  meta.patientId = meta.patientId.toUpperCase();

                  patchState(store, {
                    healthRecordMeta: meta,
                    healthRecordId: healthRecordId.toUpperCase(),
                    isLoading: false }
                  );
                  globalStore.unsetLoading();
                },
                error: (e) => {
                  console.error(e);
                },
                finalize: () => {
                  globalStore.unsetLoading();
                  patchState(store, { isLoading: false });
                }
              })
            );
        })
      )
    ),
  })),
);
